/* main.tsx generated by @compiled/babel-plugin v0.38.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import "./main.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React, { memo } from 'react';
import { LazySuspense } from 'react-loosely-lazy';
import { AnalyticsContext } from '@atlaskit/analytics-next';
import { COMPONENT_NAME, LINK_PICKER_WIDTH_IN_PX } from '../common/constants';
import { LinkPickerSessionProvider } from '../controllers/session-provider';
import { ErrorBoundary } from './error-boundary';
import { LoaderFallback } from './loader-fallback';
import { MessagesProvider } from './messages-provider';
export var testIds = {
  linkPickerRoot: 'link-picker-root'
};
export var PACKAGE_DATA = {
  packageName: "@atlaskit/link-picker" || '',
  packageVersion: "0.0.0-development" || '',
  componentName: COMPONENT_NAME,
  source: COMPONENT_NAME
};
var DefaultRootComponent = function DefaultRootComponent(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": testIds.linkPickerRoot
  }, children);
};
var fixedWidthContainerStyles = null;
var FixedWidthContainer = function FixedWidthContainer(props) {
  return /*#__PURE__*/React.createElement("div", _extends({
    role: "dialog",
    "aria-modal": "false",
    "aria-label": "link-picker"
  }, props, {
    className: ax(["_1bsb1ubl"])
  }));
};
export var composeLinkPicker = function composeLinkPicker(Component) {
  return /*#__PURE__*/memo(function (props) {
    var _props$paddingLeft, _props$paddingRight, _props$paddingTop, _props$paddingBottom;
    var component = props.component;
    var RootComponent = component !== null && component !== void 0 ? component : DefaultRootComponent;
    return /*#__PURE__*/React.createElement(AnalyticsContext, {
      data: PACKAGE_DATA
    }, /*#__PURE__*/React.createElement(LinkPickerSessionProvider, null, /*#__PURE__*/React.createElement(MessagesProvider, null, /*#__PURE__*/React.createElement("div", {
      style: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, '--link-picker-width', props.disableWidth ? '100%' : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
      "".concat(LINK_PICKER_WIDTH_IN_PX, "px")), '--link-picker-padding-left', (_props$paddingLeft = props.paddingLeft) !== null && _props$paddingLeft !== void 0 ? _props$paddingLeft : "var(--ds-space-200, 16px)"), '--link-picker-padding-right', (_props$paddingRight = props.paddingRight) !== null && _props$paddingRight !== void 0 ? _props$paddingRight : "var(--ds-space-200, 16px)"), '--link-picker-padding-top', (_props$paddingTop = props.paddingTop) !== null && _props$paddingTop !== void 0 ? _props$paddingTop : "var(--ds-space-200, 16px)"), '--link-picker-padding-bottom', (_props$paddingBottom = props.paddingBottom) !== null && _props$paddingBottom !== void 0 ? _props$paddingBottom : "var(--ds-space-200, 16px)")
    }, /*#__PURE__*/React.createElement(FixedWidthContainer, null, /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(LazySuspense, {
      fallback: /*#__PURE__*/React.createElement(LoaderFallback, {
        url: props.url,
        hideDisplayText: props.hideDisplayText,
        isLoadingPlugins: props.isLoadingPlugins,
        plugins: props.plugins
      })
    }, /*#__PURE__*/React.createElement(RootComponent, _extends({}, props, {
      "data-testid": testIds.linkPickerRoot
    }), /*#__PURE__*/React.createElement(Component, props)))))))));
  });
};